import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './lib/auth';
import { initPostHog } from './lib/posthog';
import { onPreloadError } from './lib/preloadReload';
import { ErrorBoundary, RootErrorFallback } from './components/ErrorBoundary';
import './styles/tokens.css';

initPostHog();

// A screen's file gone after a deploy: reload once onto the new build.
window.addEventListener('vite:preloadError', (e) => onPreloadError(e));

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider>
        {/* The last resort. A crash in one screen is caught nearer, inside the
            shell (App.tsx); this is for a crash in the shell itself. */}
        <ErrorBoundary fallback={<RootErrorFallback />}>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
